
import React from 'react';
import Cookies from "js-cookie";
import { createCart } from '../../../AddToCart'
import SuccessModal from '../../ProductListPageComponent/SuccessModal'
import SimilarProductModal from '../../ProductListPageComponent/SimilarProductModal'
import MoreThanOneProductModal from '../../ProductListPageComponent/MoreThanOneProductModal'
import UnknownErrorModal from '../../ProductListPageComponent/UnknownErrorModal'
import citizensUtil from '../../../citizens';

class PartnerFormBlock extends React.Component {
  // checkbox = original checkbox array
  // Exampart = user selected checkbox array
  // prevSelection = to carry forward user selection checkbox with new skus when radio button selection changed
  // RadioButtonArray = for product which does not contain checkbox
  // if checkbox > 1 and all checkbox are checked the SET object price will be applied (setPrice,setpartnerPrice)
    constructor() {
        super();
        this.state = {
          selectedRadio: "",
          RadioButtonArray: [],
          ExamPart: [],
          checkbox: [],
          prevSelection: [],
          Price : 0,
          partnerPrice : null,
          addToCartModal : false,
          setPrice: 0,
          companyPrice: null,
          setcompanyPrice: null,
          setpartnerPrice: null,
          primaryBtnFocused: false,
          primaryBtnHovered: false,
          discountForOnlySET: false,
          skuArr: [],
          btnClicked: false
      };
        this.addToCart = this.addToCart.bind(this);
        this.calPrice();
      }

      componentWillMount() {
        // to bind default selected radio button/checkbox values on page load
        setTimeout(() => (
          // ============ product with radio and checkbox ================
          this.props.PackageForm && 
            (this.props.PackageForm.radio &&
              this.props.PackageForm.radio.map((item) => (
              item.title === this.props.PackageForm.radio[0].title &&
              
            item.checkbox && this.setState({
                selectedRadio: this.props.PackageForm.radio[0].title,
                RadioButtonArray : this.props.PackageForm.radio,
                checkbox : Object.keys(item.checkbox).map((key) => item.checkbox[key]),
                ExamPart:  Object.keys(item.checkbox).map((key) => item.checkbox[key])
              },() => this.state.checkbox.map((item) =>{
                if(item.title === "SET" && this.state.checkbox.length !== 1) {
                  this.setState({ 
                    setpartnerPrice : (item.partnerPrice && item.partnerPrice),
                    setPrice : item.Price,
                    setcompanyPrice: item.companyPrice !== null ? item.companyPrice : null
                  })
                }
                  
                  if(this.state.checkbox.length === 1){
                    // this.state.checkbox.length === 1 &&
                      this.setState({
                        Price: item.Price,
                        partnerPrice: item.partnerPrice,
                        companyPrice: item.companyPrice !== null ? item.companyPrice : null
                      })
                  }
              }))
            )),
            // =============== product with radio and checkbox ===================
            
            // ==================== product with only radio ======================
            this.props.PackageForm.radio &&
            this.state.checkbox.length === 0 &&
            this.setState({
              RadioButtonArray : this.props.PackageForm.radio 
            },() => this.setState({
              selectedRadio: this.state.RadioButtonArray[0].code,
              Price : this.state.RadioButtonArray[0].Price,
              partnerPrice : (this.state.RadioButtonArray[0].partnerPrice && this.state.RadioButtonArray[0].partnerPrice),
              companyPrice: this.state.RadioButtonArray[0].companyPrice !== null ? this.state.RadioButtonArray[0].companyPrice : null
              }
            )),
            // ==================== product with only radio ======================
            
            // ==================== product with only checkbox ======================
            !this.props.PackageForm.radio &&
            this.props.PackageForm.checkbox &&
            this.setState({
              checkbox : this.props.PackageForm.checkbox,
              ExamPart: this.props.PackageForm.checkbox
            },() =>  
              this.state.checkbox.map((item) =>{ 
                if(item.title === "SET" && this.state.checkbox.length !== 1){
                this.setState({
                  setpartnerPrice : (item.partnerPrice && item.partnerPrice),
                  setPrice : item.Price,
                  setcompanyPrice: item.companyPrice !== null ? item.companyPrice : null
                })  
              } 
              })
            ),
            // ==================== product with only checkbox ======================

            // ==================== product without checkbox radio ======================
            !this.props.PackageForm.radio &&
            !this.props.PackageForm.checkbox &&
            this.setState({
              Price : this.props.PackageForm.Price,
              partnerPrice : (this.props.PackageForm.partnerPrice && this.props.PackageForm.partnerPrice),
              companyPrice: this.props.PackageForm.companyPrice !== null ? this.props.PackageForm.companyPrice : null
            })
          )
          // ==================== product without checkbox radio ======================
        ), 1)    
      }

      citizenBankUtil() {
          var isSet = (this.state.checkbox.length === this.state.ExamPart.length) ? true : false;
          var isonlyRadio = this.props.PackageForm.radio && this.state.checkbox.length === 0;
          var isonlyPrice = !this.props.PackageForm.radio && !this.props.PackageForm.checkbox;
          
          var offerPrice = isonlyPrice ? ((this.state.partnerPrice && this.state.partnerPrice !== 0) ? this.state.partnerPrice : this.state.Price ) : 
          (isonlyRadio ? ((this.state.partnerPrice && this.state.partnerPrice !== 0) ? this.state.partnerPrice : this.state.Price) : ((isSet && this.state.checkbox.length !== 1) ? ((this.state.setpartnerPrice && this.state.setpartnerPrice !== 0) ? this.state.setpartnerPrice : this.state.setPrice) : ((this.state.partnerPrice && this.state.partnerPrice !== 0) ? this.state.partnerPrice : this.state.Price)));
          return offerPrice;
      }

      citizensSetPrice() {
        var offerPrice = this.citizenBankUtil();
        this.setState({ offerPrice })

		    //set link for check eligibility window on change of price
        //setLinkHref is function of external js jifiti.js, this function is used for setting link after appending price parameter
        var linkHref = !window.location.origin.includes('www.efficientlearning.com') ? 'https://wiley.cfqa.jifiti.com/?ra='+offerPrice.toFixed(2) : 'https://wiley.citizensone.com/?ra='+offerPrice.toFixed(2);

        this.state && typeof window.OfferByPrice.init !== "undefined" && window.OfferByPrice && (offerPrice >= global.citizenMinValue && offerPrice <= global.citizenMaxValue) && window.OfferByPrice.setLinkHref(`OfferByPrice`+this.props.index,linkHref);
        this.state && window.OfferByPrice && global.citizenMinValue !== undefined && offerPrice >= global.citizenMinValue && offerPrice <= global.citizenMaxValue && window.OfferByPrice.setPrice(`OfferByPrice`+this.props.index,offerPrice)
      }

      componentDidMount() {
        setTimeout(() => {
          var isSet = (this.state.checkbox.length === this.state.ExamPart.length) ? true : false;
          var isonlyRadio = this.props.PackageForm.radio && this.state.checkbox.length === 0;
          var offerPrice = this.citizenBankUtil();
          this.setState({ offerPrice })

          Cookies.get('geolocation') === "US" && offerPrice && this.props.PackageForm !== undefined && 
        (this.props.PackageForm.radio || this.props.PackageForm.checkbox || this.props.PackageForm.code) && ( window.OfferByPrice && document.getElementById(`OfferByPrice`+this.props.index) && (isSet ? (isonlyRadio ? this.state.partnerPrice !== 0 : this.state.setpartnerPrice !== 0) : this.state.partnerPrice !== 0) && citizensUtil(`OfferByPrice`+this.props.index,offerPrice) )
        },1000);
      }

      toggleFocusPrimaryButton = () => {
        this.setState(prevState => ({
            primaryBtnFocused: !prevState.primaryBtnFocused
        }))
      }
      toggleHoverPrimaryButton = () => {
          this.setState(prevState => ({
            primaryBtnHovered: !prevState.primaryBtnHovered
          }))
      }
      
      closeModalHandler = () => {
        this.setState({
          addToCartModal : false,
          primaryBtnHovered: false,
          primaryBtnFocused: false
        },()=>{document.body.style.overflow = "auto";})
      }

      skucode = ""
      couponCode = ""
      addToCart = (event) => {
        event.preventDefault();
        this.skucode = this.state.checkbox.length > 1 ? (this.state.ExamPart.length === this.state.checkbox.length ?
          (this.state.ExamPart.filter((sku) => sku.title === "SET" && sku.code)) : (this.state.ExamPart.filter((sku) => sku.title != "SET" && sku.code)))
         : (this.props.PackageForm !== undefined &&
           !this.props.PackageForm.radio &&
          !this.props.PackageForm.checkbox ? this.props.PackageForm.code : (this.state.checkbox.length !== 1 ? this.state.selectedRadio : this.state.checkbox[0].code))
        
        //  =========product which doesn't have checkbox store coupon code for selected radio button==========
        this.state.checkbox.length === 0 && this.state.RadioButtonArray.filter((item) => (item.code === this.state.selectedRadio && (this.couponCode = item.topPriorityCouponCode)))
        this.state.checkbox.length === 1 && (this.couponCode = this.state.checkbox[0].topPriorityCouponCode)
        this.state.checkbox.length === 0 && this.state.RadioButtonArray.length === 0 && (this.couponCode = this.props.PackageForm.topPriorityCouponCode)
        
        // ==============  if coupon code is not available then do not pass that field in API ==============
        let data = this.couponCode !== null ? {
          products: this.state.checkbox.length > 1 ? this.skucode.map(({code}) => ({ code })) : [{"code" : this.skucode}],
          couponCode: this.state.checkbox.length > 1 ?
             (this.skucode[0].topPriorityCouponCode) : this.couponCode,
          partnerId: this.props.partnerId
        } : { products: this.state.checkbox.length > 1 ? this.skucode.map(({code}) => ({ code })) : [{"code" : this.skucode}],
              partnerId: this.props.partnerId
            }
        
        var self = this;

        self.setState({
          btnClicked: true
        })
        createCart(data)
        .then(function () {
          self.setState({
            btnClicked: false,
            addToCartModal: true
          },()=>{document.body.style.overflow = "hidden";})
        })
      }
      
    
      handleCheckboxChange = (e) => {
       var insertItem = {}
        if(e.target.checked){ 
          (this.state.checkbox.length >= 1 && this.state.checkbox.map((t) => {
            // add item to ExamPart when checked
            if(e.target.value === t.code) {
              insertItem = t
              this.setState({
                ExamPart : [...this.state.ExamPart, insertItem]
              },() => {
                this.setState({
                  prevSelection : this.state.ExamPart.map((item) => item.title)
                },() =>
                  this.state.checkbox.length !== this.state.ExamPart.length &&
                  this.setState({
                    ExamPart : this.state.checkbox.filter((item) => this.state.prevSelection.indexOf(item.title) !== -1) 
                  }),
                this.calPrice()
              )
            })}
          }))
        }else 
          {   
            // remove item from ExamPart when unchecked   
             if(this.state.ExamPart.length > 2){ this.setState({
                ExamPart : this.state.ExamPart.filter((item) => (item.code !== e.target.value ))
              },() => { 
                this.setState({
                  prevSelection : this.state.ExamPart.map((item,i) => item.title)
                },() =>
                  this.state.checkbox.length !== this.state.ExamPart.length &&
                  this.setState({
                    ExamPart : this.state.checkbox.filter((item,i) => this.state.prevSelection.indexOf(item.title) !== -1) 
                  }),
                this.calPrice())
              })
             }else{ 
              //prevent user to uncheck all checkbox
              e.preventDefault()
            }
      }
    }

    handleRadioChange = (e) => {
      let arrValue = [];
      let setObj = {};
      this.props.PackageForm.radio.map((item) => {
        // ================== product with checkbox ================
        item.title === e.target.value &&
        item.checkbox && Object.keys(item.checkbox).map((key) => item.checkbox[key]).forEach((subitem) => {  
          arrValue = arrValue.concat(subitem);
          
          if(subitem.title === "SET")
          {
            setObj = subitem
            this.setState({
            checkbox : arrValue,
            selectedRadio : e.target.value,
            setPrice: setObj.Price,
            setpartnerPrice: (setObj.partnerPrice && setObj.partnerPrice),
            setcompanyPrice: setObj.companyPrice ? setObj.companyPrice : null
            },() => {
            this.state.checkbox.length === this.state.ExamPart.length ?
            this.setState({
              ExamPart: arrValue
            },() => Cookies.get('geolocation') === "US" && this.citizensSetPrice()) :
              this.setState({
                ExamPart : this.state.checkbox.filter((item) => this.state.prevSelection.indexOf(item.title) !== -1)
              },() => this.calPrice())
              }
           )
          } 
          
          //checkbox with only one checkbox hence without SET object
          if(Object.keys(item.checkbox).length === 1){
            setObj = subitem
            this.setState({
              checkbox : arrValue,
              selectedRadio: e.target.value,
              Price: setObj.Price,
              partnerPrice: setObj.partnerPrice,
              companyPrice: setObj.companyPrice && setObj.companyPrice,
              ExamPart: arrValue
            },() => Cookies.get('geolocation') === "US" && this.citizensSetPrice())
          }
        }) 

        // ================== product without checkbox ================
        item.title === e.target.value && this.state.checkbox.length === 0 &&
        (
          this.setState({
            Price: item.Price,
            partnerPrice: (item.partnerPrice && item.partnerPrice),
            companyPrice: item.companyPrice ? item.companyPrice : null,
            selectedRadio: item.code
          },() => Cookies.get('geolocation') === "US" && this.citizensSetPrice())
        )
      });
    }

    toggleCheckboxButton = (index) => {
      this.setState({
          currentIndex: index
      })
  }

    numberFormat = (value) =>
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(value);
    
    // Price calculation for checkbox
    sumPrice = null;
    sumpartnerPrice = null;
    discountForOnlySET = false;
    sumcompanyPrice = null;
    calPrice = () =>(
      this.sumPrice = null,
      this.sumpartnerPrice = null,
      this.sumcompanyPrice = null,
      
      this.state.ExamPart.map((item) => {
        if(item.title !== "SET") {
          this.sumpartnerPrice = item.partnerPrice !== null ? (this.sumpartnerPrice + item.partnerPrice) : null
          this.sumPrice = item.Price !== null ? (this.sumPrice + item.Price) : this.sumPrice
          //discountForOnlySET checks if discount price if only available for SET and not for individual checkbox
          this.discountForOnlySET = (this.state.setpartnerPrice !== null && this.state.setpartnerPrice !== null) && (item.title !== "SET" && item.partnerPrice === null) ? true : false
          this.sumcompanyPrice = item.companyPrice !== null ? (this.sumcompanyPrice + item.companyPrice) : null
        } 
        //when all checkbox (SET) is selected and has discount price then false to show discounted price
        
        if(this.state.ExamPart.length === this.state.checkbox.length) {
          this.discountForOnlySET =  (this.state.setpartnerPrice !== null) ? false : true
        }

        this.setState({ 
          Price : this.sumPrice !== null && this.sumPrice,
          partnerPrice : (this.sumpartnerPrice !== null ? this.sumpartnerPrice : null),
          discountForOnlySET : this.discountForOnlySET,
          companyPrice : this.sumcompanyPrice,
         },() => Cookies.get('geolocation') === "US" && this.citizensSetPrice())
      })
    )

  render() {
    const { PackageForm } = this.props;
    var isSet = this.state.checkbox.length === this.state.ExamPart.length;
    var isonlyRadio = this.props.PackageForm.radio && this.state.checkbox.length === 0;
    var isonlyPrice = !this.props.PackageForm.radio && !this.props.PackageForm.checkbox;
   
    return (
      PackageForm !== undefined && PackageForm !== undefined &&
      !this.props.PackageForm.radio &&
      !this.props.PackageForm.checkbox && !this.props.PackageForm.code ? <h1 className="formDataError">This Product is not available !</h1> :
      <div className="col">
       {PackageForm.radio && <p className="package-selection-format">Format</p>}
        <form onSubmit={this.addToCart}>
          {/* radio button block  */}
          {PackageForm.radio &&
            <div className="btn-group btn-group-toggle" data-toggle="buttons">
              {
                PackageForm.radio.map((radio,i) => (
                  (i === 0) ?
                    <React.Fragment key={i+this.props.index}>
                    <label htmlFor={radio.title+this.props.index} className={`btn btn-secondary print-ebook active`} key={i+this.props.index} >
                      <input type="radio" name="product" value={radio.title} id={radio.title+this.props.index} autoComplete="off" defaultChecked onClick={this.handleRadioChange} />
                      {radio.title}
                    </label>
                    {/* hidden field for digital Data */}
                    {radio.code && <span hidden key={radio.title+this.props.index} className={radio.title} name={radio.title} value={radio.code} />}
                    </React.Fragment>
                  :
                  <React.Fragment key={i+this.props.index}>
                    <label htmlFor={radio.title+this.props.index} className="btn btn-secondary ebook-only" key={i+this.props.index}>
                      <input type="radio" name="product" value={radio.title} id={radio.title+this.props.index} autoComplete="off" onClick={this.handleRadioChange} />
                      {radio.title}
                    </label>
                    {/* hidden field for digital Data */}
                    {radio.code && <span hidden key={radio.title+this.props.index} className={radio.title} name={radio.title} value={radio.code} />}
                  </React.Fragment>
                  )
                )
            }
          </div>}
          {/* ===========================  product with checkbox starts =========================== */}
          {/* checkbox button block  */}
          {this.state.checkbox.length !== 0 && (
            <>
              <p className="package-selection-exam-parts">Exam Parts</p>
              <div className="row">
                {this.state.checkbox !== undefined && this.state.checkbox.map((checkboxData,i) => (
                  (checkboxData.title !== "SET" ?
                  <React.Fragment key={i}>
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 checkbox-cols" key={i}>
                  <div className="custom-control form-control-lg custom-checkbox">
                  <input type="checkbox" name="sku" id={checkboxData.code} value={checkboxData.code} 
                  onClick={this.handleCheckboxChange} className="custom-control-input" defaultChecked={true} />
                    <label htmlFor={checkboxData.code} className="custom-control-label checkbox-title">
                      {checkboxData.title}
                    </label>
                  </div>
                </div>
                {/* hidden field for digital Data */}
                {this.state.checkbox.length === 1 && <span hidden key={checkboxData.title} className={checkboxData.title} name={checkboxData.title} value={checkboxData.code} />}
                </React.Fragment>
                : 
                //to use SET SKU in digital Data at backend
                checkboxData && <span hidden key={checkboxData.title} className={checkboxData.title} name={checkboxData.title} value={checkboxData.code} />)
                ) )}
              </div>
            </>)}

          {/* ============= price logic with checkbox and radio starts ============================= */}
          {this.state.ExamPart && this.state.ExamPart.length !== 0 && 
          this.state.ExamPart.length !== undefined && this.state.ExamPart.map((item) => (
            item.title === "SET" && this.state.ExamPart.length > 1 
            ?
            (
              // checks if discount price is only for SET otherwise show only new price block
             this.state &&
            <React.Fragment key={item.title}>
              {
                <div className="row price-breakdown">
                  <div className="col-12 col-lg-4">
                    {this.state.ExamPart.length === this.state.checkbox.length 
                    ?  (
                       <>
                        {this.state.setpartnerPrice !== null && 
                          <>
                            <p>List Price</p>
                            <p className="last-price"> {this.numberFormat(this.state.setPrice)}</p>
                          </>}

                        {/* if partner price is only in SET then show Price without break through css */}
                        {!this.state.setpartnerPrice && this.state.setpartnerPrice !== 0 && this.state.setPrice && 
                        <>
                           <p>List Price</p>
                           <p className="your-price">{this.numberFormat(this.state.setPrice)}</p>
                        </>}
                       </>                        
                      ) 
                    : (<>
                        {this.state.partnerPrice !== null &&
                        <>
                          <p>List Price</p>
                          <p className="last-price">{this.numberFormat(this.state.Price)}</p>
                        </>
                        }
                      
                        {/* if partner price is only in SET then show Price without break through css */}
                         {!this.state.partnerPrice && this.state.partnerPrice !== 0 && 
                         <>
                          <p>List Price</p>
                          <p className="your-price"> {this.numberFormat(this.state.Price)} </p>
                         </>
                         }
                        </>                        
                      ) 
                      }
                  </div>

                  {(this.state.companyPrice !== null || this.state.setcompanyPrice !== null)
                  && <div className="col-6 col-lg-4">
                      {(this.state.companyPrice !== 0  || this.state.setcompanyPrice !== 0) && <p>Company Price</p>}
                      {(this.state.companyPrice !== 0 || this.state.setcompanyPrice !== 0) && <p>
                        {this.state.ExamPart.length === this.state.checkbox.length ? 
                         this.numberFormat(this.state.setcompanyPrice) : this.numberFormat(this.state.companyPrice)}</p>}
                     </div>}
                </div>
            }
              <div className="row">
                <div className="col-12">
                    {this.state.ExamPart.length === this.state.checkbox.length ? 
                    (<>
                    {(this.state.setpartnerPrice !== null) && <p className="your-price-title">Your Price</p>}
                    <p className="your-price">
                      {this.state.setpartnerPrice !== null && this.numberFormat(this.state.setpartnerPrice)}
                    </p>
                    </>
                    )
                    : (<>
                    {(this.state.partnerPrice !== null) && <p className="your-price-title">Your Price</p>}
                    <p className="your-price">
                      {(this.state.partnerPrice !== null && this.numberFormat(this.state.partnerPrice))}
                    </p>
                    </>
                      )
                   }
                </div>
            </div>
            </React.Fragment>
            ) : 
            
            (this.state.checkbox.length === 1 &&
              <React.Fragment key={item.title}>
                <div className="row price-breakdown">
                {this.state.partnerPrice !== null && this.state.Price &&  <div className="col-12 col-lg-4">
                    <p>List Price</p>
                    <p className="last-price">{this.numberFormat(this.state.Price) }</p>
                  </div>}

                  {this.state.companyPrice && this.state.companyPrice !== null 
                  && <div className="col-6 col-lg-4">
                      {this.state.companyPrice !== 0 && <p>Company Price</p>}
                      {this.state.companyPrice !== 0 && <p>{this.numberFormat(this.state.companyPrice)}</p>}
                     </div>}
                </div>
                
                <div className="row">
                  <div className="col-12">
                    {this.state.partnerPrice !== null && <p className="your-price-title">Your Price</p>}
                    {this.state.partnerPrice !== null && <p className="your-price">{this.numberFormat(this.state.partnerPrice)}</p>}
                  </div>

                  {!this.state.partnerPrice && this.state.partnerPrice !== 0 &&
                    <div className="col-12">
                      <p>List Price</p>
                        <p className="your-price">
                        {this.numberFormat(this.state.Price)}
                      </p>
                    </div>}
                </div>
                
            </React.Fragment>
            )
          )
          )}
          {/* ===============================  product with checkbox ends =================================== */}

          {/* ====================  product with only radio button or product with only price ============================ */}
               { this.state.checkbox.length === 0 &&
              <> 
              <div className="row price-breakdown">
              {this.state.Price && this.state.partnerPrice !== null &&
                <div className="col-12 col-lg-4">
                   <p>List Price</p>
                  <p className="last-price">{this.numberFormat(this.state.Price) }</p>
                </div>}

                {this.state.companyPrice && this.state.companyPrice !== null
                  && <div className="col-6 col-lg-4">
                      {this.state.companyPrice !== 0 && <p>Company Price</p>}
                      {this.state.companyPrice !== 0 && <p>{this.numberFormat(this.state.companyPrice)}</p>}
                     </div>}
               </div>
               
               {/* partner price is not available then show price */}
               {!this.state.partnerPrice && this.state.partnerPrice === null && 
                  <div className="row only-list-price">
                    <div className="col-12 col-lg-4">
                        <p>List Price</p>
                        <p className="your-price">
                            {this.numberFormat(this.state.Price)}
                        </p>
                    </div>
                  </div>}

               <div className="row">
                  <div className="col-12">
                  {this.state.partnerPrice !== null && <p className="your-price-title">Your Price</p>}
                    <p className="your-price">{(this.state.partnerPrice !== null && this.numberFormat(this.state.partnerPrice))}</p>
                  </div>
                </div>
              </>
              }
          {/* ========================  product with only radio button or product with only price ====================== */}

          {/* ===================== for citizens bank ================== */}
          {Cookies.get('geolocation') === "US" &&  global.citizenMinValue !== undefined && ((isonlyPrice || isonlyRadio) ? this.state.partnerPrice !== 0 : (isSet ? this.state.setpartnerPrice !== 0 : this.state.partnerPrice !== 0)) && <div id={`OfferByPrice`+this.props.index} style={{display: (this.state.offerPrice >= global.citizenMinValue && this.state.offerPrice <= global.citizenMaxValue) ? 'block' : 'none'}}></div>}
          {/* ===================== for citizens bank ================== */}

          <div className="row">
            {
            <div className="col">
              <button type="submit"
                className={`add-to-cart-btn ${this.state.primaryBtnFocused? "blue-btn-focused":""} ${this.state.primaryBtnHovered? "primary-btn-hovered":""}`}
                disabled={this.state.btnClicked}
                onFocus={() => this.toggleFocusPrimaryButton()}
                onBlur={() => this.toggleFocusPrimaryButton()}
                onMouseEnter={() => this.toggleHoverPrimaryButton()}
                onMouseLeave={() => this.toggleHoverPrimaryButton()}>
                  ADD TO CART
                  {this.state.btnClicked && <i className="fa fa-spinner fa-spin"></i>}
              </button>
              {/* Add to cart button */}
            </div>}
            {/* // <!-- add to cart modal starts --> */}
            
            <div className={`${this.state.addToCartModal ? "modal-show" : "modal fade" }`} id="addToCartmodal" role="dialog"
                aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-close-icon-container">
                            <span className="fa fa-times-circle modal-close-icon" data-dismiss="modal" onClick={this.closeModalHandler}></span>
                        </div>
                        {global.isSuccess && <SuccessModal productName={this.props.title} closeModalHandler={this.closeModalHandler}/>}
                        {global.similarProduct && <SimilarProductModal closeModalHandler={this.closeModalHandler}/> }
                        {global.quantityMoreThanOne && <MoreThanOneProductModal closeModalHandler={this.closeModalHandler}/> }
                        {global.unknownError && <UnknownErrorModal closeModalHandler={this.closeModalHandler}/> }
                    </div>
                </div>
            </div>
            
            {/* // <!-- add to cart modal ends --> */}
            
          </div>
        </form>
      </div>
    );
  }

}

export default PartnerFormBlock;